import { render, staticRenderFns } from "./popUser.vue?vue&type=template&id=5290bc6d&"
import script from "./popUser.vue?vue&type=script&lang=js&"
export * from "./popUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports